/**
 *
 * Manage Reject Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Modal from "react-bootstrap/Modal"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Badge,
  Spinner,
  // Badge
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as manageRejectAction from "../../store/bWFuYWdlUmVqZWN0/actions"
import { isEmpty } from "lodash"
import * as salesAction from "../../store/c2FsZXM/actions"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ToastContainer, toast } from "react-toastify"
import api from "helpers/Api"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import loadertable from "../../assets/images/loader-table.gif"

const ManageReject = (props) => {
  const title = "Manage Reject"

  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()
 
  const { SearchBar } = Search
  const today = moment().format("YYYY-MM-DD")
  useEffect(() => {
    dispatch(manageRejectAction.loadRecordsMetaData())
    setTimeout(() => {
      dispatch(
        manageRejectAction.loadManageRejectList({
          page: 1,
          limit: 50,
          fromDate: today,
          toDate: today,
        })
      )
    }, 2000)
    setApplyFilter(false)
    dispatch(salesAction.loadEmployee())
  }, [])

  const [pageLoading, setPageLoading] = useState(true)
  const [loading, setLoading] = useState(false)
  const [applyFilter, setApplyFilter] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false)
    }, 1000)
  }, [])


  const salesUpdate = useSelector((specificstate) => specificstate.sales)
  const permissionUpdate = useSelector(
    (specificstate) => specificstate.manageReject
  )
  const { employee_list = [] } = salesUpdate
  const { manageRejectMetaData = {}, reject_details = [] } = permissionUpdate

  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate


  
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const [btnLoader, setBtnLoader] = useState(false)
  const [rejectData, setRejectData] = useState({
    company: [],
    branch: [],
    department: [],
    salesAgent: [],
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [rejectReason, setRejectReason] = useState([])
  const [priorityCode, setPriorityCode] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [followupView, setFollowupView] = useState(false)
  const [followupDetails, setFollowupDetails] = useState("")
  const [eventView, setEventView] = useState(false)
  const [eventDetails, setEventDetails] = useState("")
  const [isPremium, setIsPremium] = useState("")
  const [venueName, setVenueName] = useState([])

  const handleEventClose = () => setEventView(false)
  const handleFollowupClose = () => setFollowupView(false)

  //dropdown options api
  const branchOptions =
    !isEmpty(manageRejectMetaData) &&
    manageRejectMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //Employee list
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.empCode = element.empCode
        obj.label = labelEmployee
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const priority =
    !isEmpty(priorityCode) && priorityCode.map((priority) => priority.value)
 
  const handleChange = async (e) => {
    setRejectData({ ...rejectData, [e.target.name]: e.target.value })
  }

  const statusList = [
    {
      label: "Is Premium",
      value: true,
    },
  ]

 
  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setIsPremium(value)
      // setAuditChecked(true)
    } else {
      setIsPremium(false)
    }
  
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Apply filter
  const handleFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchVenue = venueName && venueName ? venueName.value : ""

    var searchEmpCode = salesAgent && salesAgent.value ? salesAgent.value : ""
    var searchPriority = priorityCode && priorityCode ? priority : ""
    var searchReject = rejectReason && rejectReason ? rejectReason.value : ""
    var searchFromDate =
      rejectData && rejectData.fromDate
        ? moment(rejectData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      rejectData && rejectData.toDate
        ? moment(rejectData.toDate).format("YYYY-MM-DD")
        : ""

    var searchPremium = isPremium == true ? true : false
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchVenue) {
      searchvalue.venueName = searchVenue
    }
    if (searchEmpCode) {
      searchvalue.leadAssign = searchEmpCode
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }
    if (searchPriority) {
      searchvalue.priorityId = searchPriority
    }
    if (searchReject) {
      searchvalue.rejectReason = searchReject
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }

 
    specificDispatch(manageRejectAction.loadManageRejectList(searchvalue))
    setPageLoad(!pageLoad)
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  //reset functionalities
  const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesUrge([])
    setPriorityCode([])
    setSalesAgent([])
    setRejectReason([])
    setVenueName([])
    setIsPremium(false)
    setRejectData({
      fromDate: today,
      toDate: today,
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      manageRejectAction.loadManageRejectList({
        page: 1,
        limit: 50,
        fromDate: today,
        toDate: today,
      })
    )
  }

  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setRejectData({
          ...rejectData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])
 
 
  let slNo = 0
  const rejectDataTable = !isEmpty(reject_details)
    ? reject_details.data.map((rejectData, index) => {
      slNo = slNo + 1

      const eventDateDetails =
        !isEmpty(rejectData.eventDetails) && rejectData.eventDetails
          ? rejectData.eventDetails.map((date) =>
            !isEmpty(date.eventDate)
              ? moment(date.eventDate)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(dateFormate)
              : []
          )
          : []
      const eventLocationDetails =
        !isEmpty(rejectData.eventDetails) && rejectData.eventDetails
          ? rejectData.eventDetails.map((date) => date.venueLocation)
          : []
      var time =
        !isEmpty(rejectData.rejectedOn) && rejectData.rejectedOn
          ? moment(rejectData.rejectedOn)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(`${dateFormate} hh:mm A`)
          : []
      var leadDate =
        !isEmpty(rejectData.leadDate) && rejectData.leadDate
          ? moment(rejectData.leadDate)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(dateFormate)
          : []
      // aging and reassign difference 
      const currentDay = moment().startOf('day')
      const createdDate = rejectData.leadDate ? moment.utc(rejectData.leadDate).startOf('day') : ""
      const assignedDate = rejectData.leadAssignDate ? moment.utc(rejectData.leadAssignDate).startOf('day') : ""

      const createdDifference =
        currentDay && !isEmpty(createdDate)
          ? currentDay.isValid() && createdDate.isValid()
            ? Math.ceil(currentDay.diff(createdDate, 'days', true))
            : ""
          : ""
      const assignDifference =
        currentDay && !isEmpty(assignedDate)
          ? currentDay.isValid() && assignedDate.isValid()
            ? Math.ceil(currentDay.diff(assignedDate, "days", true))
            : ""
          : ""
      const dayDiffValue = `${createdDifference}/${assignDifference} days`
     
      return {
        _id: rejectData._id,
        sNo: slNo,
        leadId:rejectData.leadId,
        clientName: rejectData.clientName,
        action: (
          <Button
            type="submit"
            style={{ fontSize: "10px" }}
            className="btn btn-success buttons"
          >
            <i className="fas fa-pen icon-btn"></i>
          </Button>
        ),
        attachments: rejectData.attachments,
        clientNo: rejectData.clientNo,
        branchId: rejectData.branchId,
        branchName: rejectData.branchName,
        phoneNo: rejectData.contact,
        rejectRemarks: rejectData.rejectedRemarks,
        rejectQc: rejectData.rejectedQc,
        rejectedDate: time,
        leadStatus: rejectData.processStatusName,
        quoteGiven: rejectData.quotationGiven,
        quoteCode: rejectData.quoteCode,
        budget: rejectData.budget,
        quoteRevise: rejectData.quoteRevise,
        enquiryDate: leadDate,
        eventDetails: (
          <Badge
            className={`font-size-12 badge rounded-pill 
                bg-info badge-soft-info
            `}
            pill
            onClick={() => {
              setEventView(true)
              setEventDetails(rejectData.eventDetails)
            }}
            style={{ padding: "8px" }}
          >
            View
          </Badge>
        ),
        location:
          rejectData.eventDetails.length > 1
            ? eventLocationDetails.join(" , ")
            : "",
        eventDate:
          rejectData.eventDetails.length > 1
            ? eventDateDetails.join(" , ")
            : isEmpty(eventDateDetails)
              ? "--"
              : eventDateDetails,
        CurrentFollowupDetails: rejectData.CurrentFollowupDetails,
        followUp: (
          <div className="d-flex flex-row justify-content-center">
            <p style={{ fontSize: "12px", marginTop: "6px" }}>
              {rejectData.currentFollowupCount}
            </p>
            <i
              className="fas fa-eye icon-btn mx-3"
              style={{ fontSize: "16px", color: "#3498db", marginTop: "6px" }}
              onClick={() => {
                setFollowupView(true)
                setFollowupDetails(rejectData.CurrentFollowupDetails)
              }}
            ></i>
            {/* </Button> */}
          </div>
        ),
        remarks: rejectData.remarks,
        currentFollowupCount: rejectData.currentFollowupCount,
        rejectReasonName: !isEmpty(rejectData.rejectReasonName)
          ? rejectData.rejectReasonName.reason
          : "",
        fileName: (
          <a
            onClick={() => window.open(rejectData.rejectAttachment, "_blank")}
          >
            <span
              style={{
                textDecoration: "underline",
                color: "#E40D8C",
              }}
            >
              View Attachments
            </span>
          </a>
        ),
        leadSource: rejectData.leadSourceName,
        rejectAttachment: rejectData.rejectAttachment,
        leadNo:rejectData.leadNo,
        companyId: rejectData.companyId,
        venueName: !isEmpty(rejectData.venueName) ? rejectData.venueName : "--",
        venueLocation: !isEmpty(rejectData.venueLocation) ? rejectData.venueLocation : "--",
        isPremium: rejectData.isPrimium,
        priorityStatusName: rejectData.priorityStatusName,
        salesUrge: rejectData.salesUrge,
        companyName: rejectData.companyName,
        leadSourceName: rejectData.leadSourceName,
        subSource: rejectData.leadSubSourceName ? rejectData.leadSubSourceName : "--",
        leadAssign: rejectData.leadAssign,
        leadDate: rejectData.leadDate
          ? moment(rejectData.leadDate).format("DD-MM-YYYY hh:mm A")
          : [],
        leadServiceName: rejectData.leadServiceName,
        fromTime: rejectData.fromTime,
        toTime: rejectData.toTime,
        key: index,
        agingDate: dayDiffValue,
        salesPyramid: rejectData.salesPyramid ? rejectData.salesPyramid : "--",
        leadSubStatus: rejectData.leadSubStatus ? rejectData.leadSubStatus : "--",
       
        leadService: rejectData.leadServiceName ? rejectData.leadServiceName : "--",
        eventServices: rejectData.eventServices ? rejectData.eventServices : "--",
        crossPromotion: rejectData.crossPromotion ? rejectData.crossPromotion : "--",
        clientProfileName: rejectData.clientProfileName ? rejectData.clientProfileName : "--",
        clientProfileStatus: rejectData.clientStatus ? rejectData.clientStatus : "--",
        clientProfileRemarks: rejectData.clientProfileRemarks ? rejectData.clientProfileRemarks : "--",
      }
    })
    : []
  
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const handleFollowupHistoryModal = () => {
    setFollowupHistoryModal(false)
  }
 
  const salesFollowupUpdate = useSelector(
    (specificstate) => specificstate.salesfollowup
  )
  const { followup_history = []} = salesFollowupUpdate
  //pagination table data columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      hidden: false,
      style: () => ({
        
        textTransform: "uppercase",
        color: "#e40d8c",
      }),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      hidden: false,
      sort: true,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientProfileName",
      text: "Client Profile Name",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "clientProfileStatus",
      text: "Client Profile Status",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "clientProfileRemarks",
      text: "Client Profile Remarks",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "phoneNo",
      text: "Contact No",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "leadAssign",
      text: "Sales Agent",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "rejectQc",
      text: "Reject Qc",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      formatter: (cellContent, row) => {
      
        return (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.leadStatus === "Rejected"
              ? "bg-danger badge-soft-danger"
              : "bg-success badge-soft-success"
              }`}
            pill
          >
            {row.leadStatus}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "rejectRemarks",
      text: "Reject Remarks",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "rejectReasonName",
      text: "Reject Reason",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "rejectedDate",
      text: "Rejected Date",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "venueName",
      text: "Venue Name",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "isPremium",
      text: "Premium",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isPremium == true ? "success" : "danger"}
            style={{ padding: "8px 14px", fontSize: "12px" }}
          >
            {" "}
            {row.isPremium == true ? "Yes" : "No"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "enquiryDate",
      text: "Enquiry Date",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "quoteGiven",
      text: "Quote Given",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "quoteCode",
      text: "Quote Code",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "quoteRevise",
      text: "No of Quote Revision",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDetails",
      text: "Event Details",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      csvExport: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    
    {
      dataField: "CurrentFollowupDetails",
      text: "No of follow up",
      sort: true,
      hidden: false,
      csvExport: false,
      style: () => ({ 
        textTransform: "uppercase",
      }),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row justify-content-center">
            <p style={{ fontSize: "12px", marginTop: "6px" }}>
              {row.currentFollowupCount}
            </p>
            <i
              className="fas fa-eye icon-btn mx-3"
              style={{ fontSize: "16px", color: "#3498db", marginTop: "6px" }}
              onClick={() => {
                setFollowupView(true)
                setFollowupDetails(row.CurrentFollowupDetails)
              }}
            ></i>
            {/* </Button> */}
          </div>
        )
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    // {
    //   dataField: "remarks",
    //   text: "Call Remarks",
    //   sort: true,
    //   headerStyle: {
    //     minWidth: "140px",
    //   },
    // },
    {
      dataField: "fileName",
      text: "File Name",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <a onClick={() => window.open(row.rejectAttachment, "_blank")}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View attachments
              </span>
            </a>
          </>
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
   
    {
      dataField: "subSource",
      text: "Sub Source",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "agingDate",
      text: "Aging/Re-assigning",
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "leadSubStatus",
      text: "Lead Sub Status",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesPyramid",
      text: "Pyramid Status",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventServices",
      text: "Event Service",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "crossPromotion",
      text: "Cross Promotion",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadSource",
      text: "Lead Source",
      sort: true,
      hidden: true,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadService",
      text: "Lead Service",
      style: () => ({
        textTransform: "uppercase",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },

    // {
    //   dataField: "followupHistory",
    //   text: "Followup History",
    //   formatter: (cellContent, row) => {
    //     return (
    //       <Row>
    //         <Col md="6" lg="6" sm="6">
    //           {row.currentFollowupCount ? <div className="space-between">
    //             <span className="badge rounded-pill bg-primary">
    //               {row.currentFollowupCount}
    //             </span>
    //           </div> : "--"}

    //         </Col>
    //         <Col md="4" lg="4" sm="4">
    //           <i
    //             className="fas fa-eye text-info fs-5"
    //             onClick={() => {

    //               handleFollowupSubmit(row.leadId)
    //             }}
    //           ></i>
    //         </Col>
    //       </Row>

    //     )
    //   },
    //   hidden: true,
    //   headerStyle: {
    //     minWidth: "165px",
    //   },
    // },

    {
      dataField: "salesUrge",
      text: "Sales Urge",
      sort: true,
      hidden: false,
      style: () => ({
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
  ]
  const salesUrgeOptions = [
    {
      label: "hot",
      value: "hot",
    },
    {
      label: "warm",
      value: "warm",
    },
    {
      label: "cold",
      value: "cold",
    },
  ]
  const MySearch = (props) => {
    let input

    const handleClick = () => {
      props.onSearch(input.value)

      dispatch(
        manageRejectAction.loadManageRejectList({
          searchFilter: input.value,
          page: pageChange ? pageCount : 1,
          limit: 25,
        })
      )
    
    }
    return (
      <div className="d-flex flex-row">
        <input
          className="form-control"
          placeholder="Search"
          ref={(n) => (input = n)}
          type="text"
        />
        <button className="btn btn-success mx-2" onClick={handleClick}>
          <i className="fas fa-search"></i>
        </button>
      </div>
    )
  }
 

  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }
  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    a.style.width = "100%"
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
 

  const exportToCsv = () => {
   
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(salesUrge) ||
      !isEmpty(salesAgent) ||
      !isEmpty(rejectReason) ||
      !isEmpty(rejectData.fromDate) ||
      !isEmpty(rejectData.toDate)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchVenue = venueName && venueName ? venueName.value : ""

      var searchEmpCode = salesAgent && salesAgent.value ? salesAgent.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchReject = rejectReason && rejectReason ? rejectReason.value : ""
      var searchFromDate =
        rejectData && rejectData.fromDate
          ? moment(rejectData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        rejectData && rejectData.toDate
          ? moment(rejectData.toDate).format("YYYY-MM-DD")
          : ""
      var searchPremium = isPremium == true ? true : false

      var searchvalue = {}
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchVenue) {
        searchvalue.venueName = searchVenue
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEmpCode) {
        searchvalue.leadAssign = searchEmpCode
      }
      if (searchSalesUrge) {
        searchvalue.salesUrge = searchSalesUrge
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchReject) {
        searchvalue.rejectReason = searchReject
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }

      setPageLoad(!pageLoad)
      setDownloadLoading(true)
      api
        .post(`/get_manage_reject_reason_list_excel_export`, searchvalue)
        .then((response) => {
          const rejectExportTable = !isEmpty(response.data.data)
            ? response.data.data.map((rejectData, index) => {
             
              const eventDateDetails =
                !isEmpty(rejectData.eventDetails) && rejectData.eventDetails
                  ? rejectData.eventDetails.map((date) =>
                    !isEmpty(date.eventDate)
                      ? moment(date.eventDate)
                        .subtract(5, "hours")
                        .subtract(30, "minutes")
                        .format(dateFormate)
                      : []
                  )
                  : []
              const eventLocationDetails =
                !isEmpty(rejectData.eventDetails) && rejectData.eventDetails
                  ? rejectData.eventDetails.map((date) => date.venueLocation)
                  : []
              var time =
                !isEmpty(rejectData.rejectedOn) && rejectData.rejectedOn
                  ? moment(rejectData.rejectedOn)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                  : []
              var leadDate =
                !isEmpty(rejectData.leadDate) && rejectData.leadDate
                  ? moment(rejectData.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(dateFormate)
                  : []
              var rejectedRemarks = !isEmpty(rejectData.rejectedRemarks)
                ? rejectData.rejectedRemarks.replace(/[\r\n,.]/gm, "")
                : "--"
           
              const venueNameValue = rejectData.venueName === "," ? "--" : !isEmpty(rejectData.venueName)
                ? JSON.stringify(rejectData.venueName).replace(/","/g, "\n")
                : "--"


              const venueLocationValue = rejectData.venueLocation === ","
                ? "--"
                : !isEmpty(rejectData.venueLocation)
                  ? JSON.stringify(rejectData.venueLocation).replace(/","/g, "\n")
                  : "--"
              const reasonName = !isEmpty(rejectData.rejectReasonName)
                ? rejectData.rejectReasonName.reason
                : ""
              const reasonNameValue = !isEmpty(reasonName)
                ? reasonName.replace(/[\r\n,.]/gm, "")
                : "--"
              // aging and reassign difference 
              const currentDay = moment().startOf('day')
              const createdDate = rejectData.leadDate ? moment.utc(rejectData.leadDate).startOf('day') : ""
              const assignedDate = rejectData.leadAssignDate ? moment.utc(rejectData.leadAssignDate).startOf('day') : ""

              const createdDifference =
                currentDay && !isEmpty(createdDate)
                  ? currentDay.isValid() && createdDate.isValid()
                    ? Math.ceil(currentDay.diff(createdDate, 'days', true))
                    : ""
                  : ""
              const assignDifference =
                currentDay && !isEmpty(assignedDate)
                  ? currentDay.isValid() && assignedDate.isValid()
                    ? Math.ceil(currentDay.diff(assignedDate, "days", true))
                    : ""
                  : ""
              const dayDiffValue = `${createdDifference}/${assignDifference} days`
              const clientProfileRemarksValue = !isEmpty(rejectData.clientProfileRemarks)
              ? JSON.stringify(rejectData.clientProfileRemarks).replace(/","/g, "\n")
              : "--"
              return {
                _id: rejectData._id,
                sNo: index + 1,
                clientName: rejectData.clientName,
                action: (
                  <Button
                    type="submit"
                    style={{ fontSize: "10px" }}
                    className="btn btn-success buttons"
                  >
                    <i className="fas fa-pen icon-btn"></i>
                  </Button>
                ),
                attachments: rejectData.attachments,
                clientNo: rejectData.clientNo,
                branchId: rejectData.branchId,
                branchName: rejectData.branchName,
                phoneNo: rejectData.contact,
                rejectRemarks: rejectedRemarks,
                rejectQc: rejectData.rejectedQc,
                rejectedDate: time,
                leadStatus: rejectData.processStatusName,
                venueName: venueNameValue,
                venueLocation: venueLocationValue,
                isPremium: rejectData.isPrimium == true ? "Yes" : "No",
                quoteGiven: rejectData.quotationGiven,
                quoteCode: rejectData.quoteCode,
                budget: rejectData.budget,
                quoteRevise: rejectData.quoteRevise,
                enquiryDate: leadDate,
                location:
                  rejectData.eventDetails.length > 1
                    ? eventLocationDetails.join(" , ")
                    : "",
                eventDate:
                  rejectData.eventDetails.length > 0
                    ? eventDateDetails[0]
                    : "--",
                remarks: rejectData.remarks,
                currentFollowupCount: rejectData.currentFollowupCount,
                rejectReasonName: reasonNameValue,
                leadSource: rejectData.leadSourceName,
                rejectAttachment: rejectData.rejectAttachment,
                leadNo: rejectData.leadNo,
                companyId: rejectData.companyId,
                priorityStatusName: rejectData.priorityStatusName,
                salesUrge: rejectData.salesUrge,
                companyName: rejectData.companyName,
                leadSourceName: rejectData.leadSourceName,
                leadAssign: rejectData.leadAssign,
                leadDate: rejectData.leadDate
                  ? moment(rejectData.leadDate).format("DD-MM-YYYY hh:mm A")
                  : [],
                leadServiceName: rejectData.leadServiceName,
                fromTime: rejectData.fromTime,
                toTime: rejectData.toTime,
                key: index,
                agingDate: dayDiffValue,
                salesPyramid:rejectData.salesPyramid?rejectData.salesPyramid:"--",
                leadSubStatus:rejectData.leadSubStatus?rejectData.leadSubStatus : "--",
              
                leadService:rejectData.leadServiceName?rejectData.leadServiceName:"--",
                eventServices:rejectData.eventServices?rejectData.eventServices:"--",
                crossPromotion:rejectData.crossPromotion?rejectData.crossPromotion:"--",
                subSource: rejectData.leadSubSourceName ? rejectData.leadSubSourceName : "--",
                clientProfileName: rejectData.clientProfileName ? rejectData.clientProfileName : "--",
                clientProfileStatus: rejectData.clientStatus ? rejectData.clientStatus : "--",
                clientProfileRemarks: clientProfileRemarksValue,
              }
            })
            : []
          setTimeout(() => {
            let headerData = [
              "S.No,Lead No,Client No,Company Name,Branch Name,Client Name,Client Profile Name,Client Profile Status, Client profile Remarks, PhoneNo,Lead Assign,RejectQc,Lead Status,  Reject Remarks, Reject Reason Name,Rejected Date,Venue Location, Venue Name, Premium, Enquiry Date, Budget,Quote Given, Quote Code, Quote Revise,Event Date, Lead Source,Sub Source,Aging/Re-assigning,Lead Sub Status,Pyamid Status,Event Services,Cross Promotion,Lead Service, Sales Urge",
            ]

            let usersCsv = !isEmpty(rejectExportTable)
              ? rejectExportTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  clientNo,
                  companyName,
                  branchName,
                  clientName,
                  clientProfileName,
                  clientProfileStatus,
                  clientProfileRemarks,
                  phoneNo,
                  leadAssign,
                  rejectQc,
                  leadStatus,
                  rejectRemarks,
                  rejectReasonName,
                  rejectedDate,
                  venueLocation,
                  venueName,
                  isPremium,
                  enquiryDate,
                  budget,
                  quoteGiven,
                  quoteCode,
                  quoteRevise,
                  eventDate,
                  leadSource,
                  subSource,
                  agingDate,
                  leadSubStatus,
                  salesPyramid,
                  eventServices,
                  crossPromotion,
                  leadService,
                  salesUrge,
                } = user
                acc.push(
                  [
                    sNo,
                    leadNo,
                    clientNo,
                    companyName,
                    branchName,
                    clientName,
                    clientProfileName,
                    clientProfileStatus,
                    clientProfileRemarks,
                    phoneNo,
                    leadAssign,
                    rejectQc,
                    leadStatus,
                    rejectRemarks,
                    rejectReasonName,
                    rejectedDate,
                    venueLocation,
                    venueName,
                    isPremium,
                    enquiryDate,
                    budget,
                    quoteGiven,
                    quoteCode,
                    quoteRevise,
                    eventDate,
                    leadSource,
                    subSource,
                    agingDate,
                    leadSubStatus,
                    salesPyramid,
                    eventServices,
                    crossPromotion,
                    leadService,
                    salesUrge,
                  ].join(",")
                )

                return acc
              }, [])
              : false
         
            if (usersCsv === false) {
              downloadFile({
                data: [...headerData].join("\n"),
                fileName: "manageReject.csv",
                fileType: "text/csv",
              })
            } else if (usersCsv !== false) {
              downloadFile({
                data: [...headerData, ...usersCsv].join("\n"),
                fileName: "manageReject.csv",
                fileType: "text/csv",
              })
            }
            setDownloadLoading(false)
          }, 4000)
          return response.data
        })
        .catch((error) => Promise.reject(error))
    
    }
  }

  const RemotePagination = ({
    data,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {(props) => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBtnStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "}
                      </Col>
                      <Col md="8">

                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginRight: "10px",
                            }}
                          >
                            Download
                          </Button>
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                      </Col>
                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
  })
  const { sizePerPage, page } = state

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
   
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(salesUrge) ||
      !isEmpty(salesAgent) ||
      !isEmpty(rejectReason) ||
      !isEmpty(rejectData.fromDate) ||
      !isEmpty(rejectData.toDate)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchVenue = venueName && venueName ? venueName.value : ""

      var searchEmpCode = salesAgent && salesAgent.value ? salesAgent.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchReject = rejectReason && rejectReason ? rejectReason.value : ""
      var searchFromDate =
        rejectData && rejectData.fromDate
          ? moment(rejectData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        rejectData && rejectData.toDate
          ? moment(rejectData.toDate).format("YYYY-MM-DD")
          : ""
      var searchPremium = isPremium == true ? true : false

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEmpCode) {
        searchvalue.leadAssign = searchEmpCode
      }
      if (searchSalesUrge) {
        searchvalue.salesUrge = searchSalesUrge
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchReject) {
        searchvalue.rejectReason = searchReject
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchVenue) {
        searchvalue.venueName = searchVenue
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }

      specificDispatch(manageRejectAction.loadManageRejectList(searchvalue))
    } else {
      dispatch(
        manageRejectAction.loadManageRejectList({
          page: page,
          limit: sizePerPage,
        })
      )
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    setState(() => ({
      page,
      data: reject_details,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            manageRejectMetaData
                              ? manageRejectMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Priority"}
                          </Label>
                        </div>
                        <Select
                          name="priorityCode"
                          value={priorityCode}
                          onChange={(e) => setPriorityCode(e)}
                          isMulti
                          options={
                            manageRejectMetaData
                              ? manageRejectMetaData.priorityOptions
                              : []
                          }
                          placeholder="Select Priority"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className={"form-label"}>{"Sales Agent"}</Label>

                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={employeeOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sales Urge"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="salesUrge"
                          value={salesUrge}
                          onChange={(e) => setSalesUrge(e)}
                          options={salesUrgeOptions}
                          placeholder="Select Sales Urge"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Reject Reason"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="rejectReason"
                          value={rejectReason}
                          onChange={(e) => setRejectReason(e)}
                          options={
                            manageRejectMetaData
                              ? manageRejectMetaData.rejectReasonList
                              : []
                          }
                          placeholder="Select Reject Reason"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Venue"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="venueName"
                          value={venueName}
                          // isMulti
                          onChange={(e) => setVenueName(e)}
                          options={
                            manageRejectMetaData
                              ? manageRejectMetaData.venueOptions
                              : []
                          }
                          placeholder="Select Venue"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Reject From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={rejectData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Reject To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={rejectData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Status"}
                          </Label>
                        </div>
                        <Select
                          name="clientStatus"
                          value={clientStatus}
                          onChange={(e) => setClientStatus(e)}
                          isMulti
                          options={clientStatusOptions}
                          placeholder="Select Priority"
                        />
                      </Col> */}
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isPremium"
                                  value={status.value}
                                  checked={isPremium === status.value}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => handleFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  {pageLoading ? (
                    <div className="d-flex flex-column">
                      <Col className="mb-3 search-bar">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div
                            className="position-relative mt-3"
                            style={searchBtnStyle || null}
                          >
                            <SearchBar />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col md="12" xl="12" lg="12">
                        {/* <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                    </p> */}
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th style={{ minWidth: "150px" }}>Lead No</th>
                              <th style={{ minWidth: "150px" }}>Client Code</th>
                              <th style={{ minWidth: "150px" }}>Company</th>
                              <th style={{ minWidth: "150px" }}>Branch</th>
                              <th style={{ minWidth: "150px" }}>Client Name</th>
                              <th style={{ minWidth: "150px" }}>Contact No</th>
                              <th style={{ minWidth: "150px" }}>Sales Agent</th>
                              <th style={{ minWidth: "150px" }}>Reject Qc</th>
                              <th style={{ minWidth: "150px" }}>Lead Status</th>
                              <th style={{ minWidth: "150px" }}>
                                Reject Remarks
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                Reject Reason
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                Rejected Date
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                Enquiry Date
                              </th>
                              <th style={{ minWidth: "150px" }}>Budget</th>
                              <th style={{ minWidth: "150px" }}>Quote Given</th>
                              <th style={{ minWidth: "150px" }}>Quote Code</th>
                              <th style={{ minWidth: "180px" }}>
                                No of Quote Revision
                              </th>
                              <th style={{ minWidth: "150px" }}>Event Date</th>
                              <th style={{ minWidth: "150px" }}>
                                Event Details
                              </th>
                              <th style={{ minWidth: "170px" }}>
                                No of follow up
                              </th>
                              <th style={{ minWidth: "150px" }}>File Name</th>
                              <th style={{ minWidth: "150px" }}>Lead Source</th>
                              <th style={{ minWidth: "150px" }}>Sales Urge</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="24">
                                <img
                                  src={loadertable}
                                  style={{ width: "100%", height: "230px" }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            {/* <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              Showing rows 0 to 0 of 0
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <>
                      <RemotePagination
                        data={rejectDataTable}
                        page={page}
                        sizePerPage={sizePerPage}
                        totalSize={reject_details.totalDataCount}
                        onTableChange={handleTableChange}
                      />

                      {loading ? (
                        <Modal
                          show={loading}
                          style={{ width: "7%", margin: "18% 50%" }}
                        >
                          <Modal.Body>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="lg"
                              role="status"
                              aria-hidden="true"
                              variant="success"
                              className="mx-2"
                              color="success"
                            />
                            {/* <span>Loading...</span> */}
                          </Modal.Body>
                        </Modal>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {followupView && (
          <Modal show={followupView} size="lg" onHide={handleFollowupClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>FOLLOWUP DETAILS</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Followup No</th>
                          <th style={{ minWidth: "110px" }}>Followup Date</th>
                          <th style={{ minWidth: "110px" }}>Followup Time</th>
                          <th style={{ minWidth: "170px" }}>Attchments</th>
                          <th style={{ minWidth: "60px" }}>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {followupDetails && followupDetails.length > 0 ? (
                          followupDetails.map((followup, index) => {
                           

                            const attachments =
                              followup.recordAttachment &&
                              followup.recordAttachment.map((record) =>
                                record.split(".").pop()
                              )
                           
                           
                            var followupDate = !isEmpty(followup.followupDate)
                              ? moment(followup.followupDate).format(
                                dateFormate
                              )
                              : []
                            return (
                              <tr key={followup._id}>
                                <td>{index + 1}</td>
                                <td>{followup.followupNo}</td>
                                <td style={{ minWidth: "110px" }}>
                                  {followupDate}
                                </td>
                                <td style={{ minWidth: "110px" }}>
                                  {followup.followupTime}
                                </td>
                                <td>
                                  {(followup.recordAttachment.length > 0 &&
                                    attachments[0] === "jpeg") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "jpg") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "png") ? (
                                    <a
                                      onClick={() =>
                                        window.open(
                                          followup.recordAttachment,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          color: "#E40D8C",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  ) : (followup.recordAttachment.length > 0 &&
                                    attachments[0] === "mp3") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "m4a") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "mp4") ? (
                                    <a href={followup.recordAttachment}>
                                      <audio controls>
                                        <source
                                          src={followup.recordAttachment}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>{followup.remarks}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={6} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setFollowupView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventView && (
          <Modal show={eventView} size="lg" onHide={handleEventClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>EVENT DETAILS</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Event No</th>
                          <th style={{ minWidth: "110px" }}>Event Name</th>
                          <th style={{ minWidth: "110px" }}>Event Date</th>
                          <th style={{ minWidth: "110px" }}>Start Time</th>
                          <th style={{ minWidth: "110px" }}>End Time</th>
                          <th style={{ minWidth: "170px" }}>Venue Location</th>
                          <th style={{ minWidth: "60px" }}>Venue Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eventDetails.length > 0 ? (
                          eventDetails.map((event, index) => {
                          
                            return (
                              <tr key={event._id}>
                                <td>{index + 1}</td>
                                <td>{event.eventNo}</td>
                                <td>{event.eventName}</td>
                                <td>
                                  {!isEmpty(event.eventDate)
                                    ? moment(event.eventDate).format(
                                      dateFormate
                                    )
                                    : "--"}
                                </td>
                                <td>{event.startTime}</td>
                                <td>{event.endTime}</td>
                                <td>{event.venueLocation}</td>
                                <td>{event.venueName}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={7} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setEventView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {btnLoading ? (
          <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {columnModal && (
          <Modal size="xl" show={columnModal}>
            <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit Columns
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setColumnModal(false)}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div>
                  <Input
                    type="checkbox"
                    checked={
                      selectedColumns.length === columns.length
                    }
                    onChange={(e) => handleSelectAllChange(e)}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <Label
                    style={{ fontSize: "16px", marginLeft: "10px" }}
                  >
                    Select All
                  </Label>
                </div>
              </Row>
              <Row>
                <Col sm="12" md="6" lg="6" className="ml-4">
                  {oddColumnData.map((column) => (
                    <div
                      key={column.dataField}
                      className="d-flex flex-row"
                    >
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(
                            column.dataField
                          )}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
                <Col sm="12" md="6" lg="6">
                  {evenColumnData.map((column) => (
                    <div
                      key={column.dataField}
                      className="d-flex flex-row"
                    >
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(
                            column.dataField
                          )}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <p
                className="text-decoration-underline text-info"
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={handleRestoreToDefault}
              >
                Restore To Default
              </p>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setColumnModal(false)
                  setSelectedColumns(selectColumn)
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleSaveColumns()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
               {followupHistoryModal && (
          <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Followup History</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>

              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th >Followup Status</th>
                      <th >Followup Date</th>
                      <th >Followup No</th>
                      <th >Followup Mode</th>
                      <th >Followup Remarks</th>
                      <th >Followup Attachment</th>
                      <th>Future Followup Date</th>
                      <th>Future Followup Mode</th>
                      {/* <th>Future Followup Remarks</th> */}
                      <th>Future Followup Strategy</th>
                      <th>Strategy Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {followup_history && !isEmpty(followup_history) ?
                      followup_history.map((item, index) => {

                        const attachment = !isEmpty(item.recordAttachment)
                          ? item.recordAttachment[0]
                          : ""
                        const attachExtension = !isEmpty(attachment)
                          ? attachment.split(".").pop()
                          : ""
                        const futureFollowupStrategyName = !isEmpty(item.futureFollowupStrategyName) ?
                          item.futureFollowupStrategyName.map(m => m).join(",") : "--"


                        const futureFollowupmodeName = !isEmpty(item.futureFollowupmodeName) ?
                          item.futureFollowupmodeName.map(m => m).join(",") : "--"

                        const followupStatusName = !isEmpty(item.followupStatusName) ?
                          item.followupStatusName.map(m => m).join(",") : "--"
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{followupStatusName}</td>
                            <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                            <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                            <td>{item.modeName ? item.modeName : "--"}</td>
                            <td>{item.remarks ? item.remarks : "--"}</td>
                            <td>
                              {" "}
                              {(attachment &&
                                attachExtension === "jpeg") ||
                                (attachment &&
                                  attachExtension === "jpg") ||
                                (attachment &&
                                  attachExtension === "png") ? (
                                <div className="d-flex flex-row align-items-center">
                                  <a
                                    onClick={() =>
                                      window.open(
                                        attachment,
                                        "_blank"
                                      )
                                    }
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>

                                </div>
                              ) : (attachment &&
                                attachExtension === "mp3") ||
                                (attachment &&
                                  attachExtension === "m4a") ||
                                (attachment &&
                                  attachExtension === "mp4") ? (
                                <a href={attachment}>
                                  <audio controls>
                                    <source
                                      src={attachment}
                                      type="audio/mpeg"
                                    />
                                    Your browser does not support the
                                    audio element.
                                  </audio>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                            <td>{item.futurefollowupDate ? moment(item.futurefollowupDate).format(dateFormate) : "--"}</td>
                            <td>{futureFollowupmodeName}</td>
                            {/* //   <td>{item.futureFollowupRemarks ? item.futureFollowupRemarks : "--"}</td> */}
                            <td>{futureFollowupStrategyName}</td>
                            <td>{item.strategyRemark ? item.strategyRemark : "--"}</td>
                          </tr>)

                      }) :
                      <tr>
                        <td className="text-align-center" colSpan={11}>
                          No Records Found...
                        </td>
                      </tr>
                    }
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleFollowupHistoryModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleFollowupHistoryModal}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

ManageReject.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageReject)
)
